
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const FolderDocument20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M4.5 3A2.5 2.5 0 0 0 2 5.5v9A2.5 2.5 0 0 0 4.5 17H11v-1H4.5A1.5 1.5 0 0 1 3 14.5V8h4.09c.4 0 .78-.16 1.06-.44L9.7 6h5.79c.83 0 1.5.67 1.5 1.5v2.09l1 1V7.5A2.5 2.5 0 0 0 15.5 5H9.7L8.23 3.51A1.75 1.75 0 0 0 6.98 3H4.5ZM3 5.5C3 4.67 3.67 4 4.5 4h2.48c.2 0 .4.08.53.22L8.8 5.5 7.44 6.85a.5.5 0 0 1-.35.15H3V5.5ZM13.25 10H15v2.5c0 .83.67 1.5 1.5 1.5H19v3.75c0 .69-.56 1.25-1.25 1.25h-4.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25ZM16 10l3 3h-2.5a.5.5 0 0 1-.5-.5V10Z"
            fill="currentColor"
        />
    </svg>
}